import styled, { css } from 'styled-components/macro';
import { ReactComponent as CloseIcon } from './close.svg';

export const Wrap = styled.div`
  background: #3376f6;
  border-radius: 16px;
  padding: 24px 32px 32px;
  display: inline-block;
  position: absolute;
  box-shadow: 0px 8px 18px rgba(57, 78, 127, 0.23);
`;

export const Close = styled(CloseIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

export const Button = styled.div<{ outline?: boolean }>`
  padding: 13px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 8px;
  cursor: pointer;
  min-width: 105px;
  text-align: center;
  ${(props) =>
    props.outline
      ? css`
          border: 1px solid #ffffff;
          color: #ffffff;
        `
      : css`
          background: #ffffff;
          color: #3376f6;
        `};
`;

export const Progress = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ProgressItem = styled.div<{ active: boolean }>`
  margin-right: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  box-sizing: content-box;
  &:nth-last-child() {
    margin-right: 0px;
  }
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid transparet;
  ${(props) =>
    props.active &&
    css`
      background: #ffffff;
      border: 1px solid #ffffff;
    `};
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #ffffff;
`;

export const Text = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;

export const Header = styled.div`
  font-weight: 700;
  font-size: 34px;
  line-height: 46px;
  color: #ffffff;
`;
